import React, { Component } from 'react'
import PropTypes from 'prop-types'

class TableListTh extends Component {
    render() {
        const { align, children, className, fullWidth } = this.props

        const modifier = align === 'center' ?
            'TableListTd--align-center ' :
            (align === 'right' ? 'TableListTd--align-right ' : '')
        
        const modifier2 = fullWidth && 'TableListTd--fullWidth'

        return (
            <th className={'TableListTh ' + modifier + modifier2 + (className || '')}>
                {children}
            </th>
        )
    }
}

TableListTh.propTypes = {
    align: PropTypes.oneOf(['center', 'right']),
    fullWidth: PropTypes.bool,
}

export default TableListTh
